@if (showResidentialPathway()) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ customerName() }}</h1>
    <h2>{{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.residential.title' | translate }}</h2>
    <p>{{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.residential.description' | translate }}</p>

    @let residential = residentialPathway()!;
    <div class="decarbonisation-pathway-total mb-4">
      <cfp-icon [icon]="'check-circle'" [iconType]="'solid'" [iconStyle]="'success'" [classes]="'me-3'" />
      <div>
        <div class="decarbonisation-pathway-total-label">
          {{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.totalReduction' | translate }}
        </div>
        <div class="decarbonisation-pathway-total-value">
          {{ residential.totalCo2IntensityReductionPercentage | number: '1.0-0' }}%
        </div>
      </div>
    </div>

    <cfp-lbg-decarbonisation-pathway-chart
      [pathway]="residential"
      [yAxisTitleKey]="'lbgPortfolioRoadmapReport.decarbonisationPathway.yAxis.average'"
    />
  </cfp-report-page>
}

@if (showNonResidentialPathway()) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ customerName() }}</h1>
    <h2>{{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.nonResidential.title' | translate }}</h2>
    <p>{{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.nonResidential.description' | translate }}</p>

    @let nonResidential = nonResidentialPathway()!;
    <div class="decarbonisation-pathway-total mb-4">
      <cfp-icon [icon]="'check-circle'" [iconType]="'solid'" [iconStyle]="'success'" [classes]="'me-3'" />
      <div>
        <div class="decarbonisation-pathway-total-label">
          {{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.totalReduction' | translate }}
        </div>
        <div class="decarbonisation-pathway-total-value">
          {{ nonResidential.totalCo2IntensityReductionPercentage | number: '1.0-0' }}%
        </div>
      </div>
    </div>

    <cfp-lbg-decarbonisation-pathway-chart
      [pathway]="nonResidential"
      [yAxisTitleKey]="'lbgPortfolioRoadmapReport.decarbonisationPathway.yAxis.average'"
    />
  </cfp-report-page>
}
